import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PrismMenuComponent,
	PrismMenuItemComponent,
	PrismSelectComponent,
	TextValueAccessor
} from '@shure/prism-angular-components';

import { LanguageSelectorComponent } from './language-selector.component';

@NgModule({
	imports: [
		CommonModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		TranslocoModule,
		PrismSelectComponent,
		PrismMenuComponent,
		PrismMenuItemComponent,
		TextValueAccessor
	],
	declarations: [LanguageSelectorComponent],
	exports: [LanguageSelectorComponent]
})
export class LanguageSelectorModule {}
